let verify = {
    authenticationFailed: "验证失败",
    authenticationSuccess: "验证成功",
    turnClick: "请依次点击",
    explain: "向右滑动完成验证",
    safetyVerification: "请完成安全验证",
}

export default verify